import { render, staticRenderFns } from "./InpatientInformation.vue?vue&type=template&id=4c1ba745&scoped=true"
import script from "./InpatientInformation.vue?vue&type=script&lang=js"
export * from "./InpatientInformation.vue?vue&type=script&lang=js"
import style0 from "./InpatientInformation.vue?vue&type=style&index=0&id=4c1ba745&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1ba745",
  null
  
)

export default component.exports